import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const getWorkingHours = catchAsync(
  async (locationId, teamMemberId, startDate, endDate) => {
    const { data } = await axiosInstance.get(
      `salon/${locationId}/team-members/${teamMemberId}/working-shifts?start_date=${startDate}&end_date=${endDate}`
    );
    return data;
  }
);

export const addWorkingHours = catchAsync(
  async (locationId, teamMemberId, body) => {
    const data = await axiosInstance.post(
      `salon/${locationId}/team-members/${teamMemberId}/working-hours`,
      body
    );
    return data;
  }
);

export const addAdditionalShift = catchAsync(
  async (locationId, teamMemberId, body) => {
    const data = await axiosInstance.post(
      `salon/${locationId}/team-members/${teamMemberId}/working-shifts`,
      body
    );
    return data;
  }
);
export const addBreak = catchAsync(
  async (locationId, teamMemberId, shiftId, body) => {
    const data = await axiosInstance.post(
      `salon/${locationId}/team-members/${teamMemberId}/${shiftId}/break`,
      body
    );
    return data;
  }
);
export const updateWorkingHours = catchAsync(
  async (locationId, teamMemberId, body) => {
    const { data } = await axiosInstance.put(
      `salon/${locationId}/team-members/${teamMemberId}/working-hours`,
      body
    );
    return data;
  }
);

export const deleteWorkingShift = catchAsync(
  async ({ locationId, teamMemberId, workingShiftId }) => {
    const { data } = await axiosInstance.delete(
      `salon/${locationId}/team-members/${teamMemberId}/working-shifts/${workingShiftId}`
    );
    return data;
  }
);
export const deleteBreak = catchAsync(
  async ({ locationId, teamMemberId, breakId }) => {
    const { data } = await axiosInstance.delete(
      `salon/${locationId}/team-members/${teamMemberId}/break/${breakId}`
    );
    return data;
  }
);
export const deleteWorkingHour = catchAsync(
  async (locationId, teamMemberId, workingHour) => {
    const { data } = await axiosInstance.delete(
      `salon/${locationId}/team-members/${teamMemberId}/working-hours/${workingHour}`
    );
    return data;
  }
);

export const getDayOffTypes = catchAsync(async () => {
  const { data } = await axiosInstance.get(`salon/time-off-types`);
  return data;
});

export const AddDayOffType = catchAsync(async (vacationType, locationId) => {
  const { data } = await axiosInstance.post(`salon/time-off-types`, {
    reason: {
      ar: vacationType,
      en: vacationType,
    },
  });
  return data;
});

export const deleteDayOffType = catchAsync(async (vacationId, locationId) => {
  const { data } = await axiosInstance.delete(
    `salon/time-off-types/${vacationId}`
  );
  return data;
});
